import React, { useState, useEffect } from "react";
import { Input, Form, Tooltip, Popover } from "antd";
import { ReactComponent as DeleteIcon } from "../../../../../../../assets/images/form_icons/MoreOptionsIcons/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../../../../../assets/images/form_icons/MoreOptionsIcons/editIcon.svg";
import { ReactComponent as SaveIcon } from "../../../../../../../assets/images/form_icons/MoreOptionsIcons/saveIcon.svg";

import style from "../props.module.sass";
// import EditCreateTeam from '../../../../organization/teams/editCreateTeam'

interface IProps {
  option: any;
  options: any;
  updateOptions: (data: any, key: string) => void;
  canEdit?: boolean;
}
const validationTypeList = [
  {
    label: "Min",
    value: "min",
    validType: "Number",
  },
  {
    label: "Max",
    value: "max",
    validType: "Number",
  },
  {
    label: "Min Length",
    value: "minlength",
    validType: "Input",
  },
  {
    label: "Max Length",
    value: "maxlength",
    validType: "Input",
  },
  {
    label: "Pattern",
    value: "pattern",
    validType: "All",
  },
];
export const ListValidationValue = (props: IProps) => {

  const { canEdit = true } = props
  const option = props.option;
  const options = props.options;

  const [isEdit, setEdit] = useState(false);

  const [label, setLabel] = useState("");
  const [value, setValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [ErrMessage, setErrMessage] = useState("");

  // const [labelErr, setLabelErr] = useState(false);
  const [valueErr, setValueErr] = useState(false);

  // const [labelErrPopup, setLabelErrPopup] = useState(false);
  const [valueErrPopup, setValueErrPopup] = useState(false);

  useEffect(() => {
    for (let i in validationTypeList) {
      if (validationTypeList[i].value === option) {
        setLabel(validationTypeList[i].label)
      }
    }
    setValue(options[option]);
    setErrorMessage(options.errorMessage || "");
  }, [option, options]);

  const checkIfPresent = (id: number, opts: any[]) => {
    return !!opts[option];
  };

  const deleteOption = () => {
    const updatedOptions = { ...options };
    if (updatedOptions[option]) {
      if (option === "pattern") {
        delete updatedOptions.errorMessage;
      }
      delete updatedOptions[option];
    }
    const validOptions = ["min", "max", "minlength", "maxlength", "pattern", "errorMessage"]
    const finalOptions: any = {}
    validOptions.forEach((item) => {
      if (updatedOptions[item]) {
        finalOptions[item] = updatedOptions[item]
      }
    })
    // sending empty field to redux to let it know that we are intentionally sending no validations
    if (Object.entries(finalOptions).length === 0) {
      finalOptions['empty'] = true
    }
    props.updateOptions(finalOptions, "properties");
  };

  const checkValue = (key: string, prop: string): boolean => {
    switch (key) {
      case "min":
        const { max } = options;
        if (!!max) {
          return Number(options["max"]) >= Number(prop);
        }
        return true;
      case "max":
        const { min } = options;
        if (!!min) {
          return Number(options["min"]) <= Number(prop);
        }
        return true;
      case "minlength":
        const { maxlength } = options;
        if (!!maxlength) {
          return Number(options["maxlength"]) >= Number(prop);
        }
        return true;
      case "maxlength":
        const { minlength } = options;
        if (!!minlength) {
          return Number(options["minlength"]) <= Number(prop);
        }
        return true;
      case "pattern":
        return prop.length > 0 ? true : false;
      default:
        return true;
    }
  };

  const editOption = () => {
    //On Save
    if (isEdit) {
      const labelPresent = checkIfPresent(option, options);
      // setLabelErr(!label || !labelPresent ? true : false);
      if (checkValue(option, value)) {
        setValueErr(false);
        setErrMessage("");
        if (label && value && labelPresent) {
          const updatedOptions = { ...options };
          updatedOptions[option] = value;
          updatedOptions["errorMessage"] = errorMessage;
          const validOptions = ["min", "max", "minlength", "maxlength", "pattern", "errorMessage"]
          const finalOptions: any = {}
          validOptions.forEach((item) => {
            if (updatedOptions[item]) {
              finalOptions[item] = updatedOptions[item]
            }
          })
          // sending empty field to redux to let it know that we are intentionally sending no validations
          if (Object.entries(finalOptions).length === 0) {
            finalOptions['empty'] = true
          }
          props.updateOptions(finalOptions, "properties");
          setEdit(!isEdit);
        }
      } else {
        setValueErr(true);
        if (option !== "pattern") {
          setErrMessage(getErrorMessage(option));
        }
      }
    } else {
      setEdit(!isEdit);
    }
  };

  const getErrorMessage = (errLabel: string): string => {
    switch (errLabel) {
      case "min":
        return "Min value should be lesser than max value";
      case "max":
        return "Max value should be greater than min value";
      case "minlength":
        return "Min-length should be less than max-length";
      case "maxlength":
        return "Max-length should be greater than min-length";
      default:
        return "Error";
    }
  };

  const popOverVisibleChange = (item: string, visible: boolean) => {
    //On mouse out
    if (!visible) {
      setValueErrPopup(false);
    } else if (item === "value" && visible) {
      valueErr ? setValueErrPopup(true) : setValueErrPopup(false);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        <Form.Item className={"a8-form-item props col-md-4"}>
          <div style={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }}>
            {label}
          </div>
        </Form.Item>

        <Form.Item className={"a8-form-item props col-md-4"}>
          <Popover
            visible={valueErrPopup}
            onVisibleChange={(visible) =>
              popOverVisibleChange("value", visible)
            }
            placement="topLeft"
            trigger="hover"
            content={
              <div style={{ color: "#ff7e7a", padding: "10px" }}>
                {value ? "Value exists" : "Empty value"}
              </div>
            }
          >
            <Input
              data-test-id="validation_value_input"
              className={`${valueErr ? style.inputError : style.input} ${style.borderRemove
                }`}
              disabled={!isEdit || !canEdit}
              placeholder="Value"
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                setValueErr(false);
                setValueErrPopup(false);
              }}
            />
          </Popover>
        </Form.Item>

        {isEdit && canEdit ? (
          <Tooltip title="Save" placement="top">
            <SaveIcon
              data-test-id="validation_save"
              onClick={() => canEdit && editOption()}
              height="20px"
              width="20px"
              style={{ marginBottom: "20px", cursor: "pointer" }}
            ></SaveIcon>
          </Tooltip>
        ) : (
          <Tooltip title="Edit" placement="top">
            <EditIcon
              data-test-id="validation_edit"
              onClick={() => canEdit && editOption()}
              height="20px"
              width="20px"
              style={{ marginBottom: "20px", cursor: "pointer" }}
            ></EditIcon>
          </Tooltip>
        )}
        <Tooltip title="Delete" placement="top">
          <DeleteIcon
            data-test-id="validation_delete"
            onClick={() => canEdit && deleteOption()}
            height="20px"
            width="20px"
            style={{ marginBottom: "20px", cursor: "pointer" }}
          ></DeleteIcon>
        </Tooltip>
      </div>
      {option === "pattern" && (
        <Form.Item label="Error Message" className="a8-form-item props">
          <Input
            data-test-id="validation_error_message_input"
            disabled={!isEdit || !canEdit}
            placeholder="Error Message"
            value={errorMessage}
            onChange={(e) => {
              setErrorMessage(e.target.value);
            }}
          />
        </Form.Item>
      )}
      {ErrMessage && (
        <p data-test-id="validation_error_message" style={{ color: "red", textAlign: "left", marginTop: "10px" }}>{ErrMessage}</p>
      )}
    </>
  );
};
